/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ForgotPasswordRequestDto } from '../models/ForgotPasswordRequestDto';
import type { PasswordResetResponseDto } from '../models/PasswordResetResponseDto';
import type { ResetPasswordRequestDto } from '../models/ResetPasswordRequestDto';
import type { ValidateTokenRequestDto } from '../models/ValidateTokenRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PasswordResetControllerService {
    /**
     * @param requestBody
     * @returns PasswordResetResponseDto OK
     * @throws ApiError
     */
    public static validateToken(
        requestBody: ValidateTokenRequestDto,
    ): CancelablePromise<PasswordResetResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/password-reset/validate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PasswordResetResponseDto OK
     * @throws ApiError
     */
    public static resetPassword(
        requestBody: ResetPasswordRequestDto,
    ): CancelablePromise<PasswordResetResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/password-reset/reset',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PasswordResetResponseDto OK
     * @throws ApiError
     */
    public static forgotPassword(
        requestBody: ForgotPasswordRequestDto,
    ): CancelablePromise<PasswordResetResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/password-reset/forgot',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
